<ng-container>
  <div class="row">
    <div class="col col-1">
    </div>
    <div class="col-2 bold">
      <p>Huidige periode</p>
    </div>
    <div class="col-3 bold">
      <p>Vorige periode</p>
    </div>
  </div>
  <ng-container *ngIf="this.showCustomControls">
    <form [formGroup]="otherIncomeExpensesAfterTaxFg">
      <div class="row">
        <div class="col col-1">
          <p style="padding: 6px">Overige baten en lasten na belasting</p>
        </div>
        <div class="col-2">
          <snelstart-ui-button type="secondary"
                               icon="plus"
                               class="custom-input-150"
                               (click)="this.showDialog(1)">Specificeer
          </snelstart-ui-button>
        </div>
        <div class="col-3">
          <snelstart-ui-number-form-control formControlName="valuePeriod1"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
        <div class="col-4">
          <snelstart-ui-number-form-control formControlName="valuePeriod2"
                                            class="custom-input-150 custom-readonly"
                                            align="right"
                                            prefix="€"
                                            [showAllDecimals]="false"
                                            [disabledControl]="true"
          >
          </snelstart-ui-number-form-control>
        </div>
      </div>
    </form>
  </ng-container>
</ng-container>
<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-trialbalance [(dialogVisible)]="this.dialogVisible"
                                                       [(input)]="this.otherIncomeExpensesAfterTaxFg"
                                                       [title]="'overige baten en lasten na belasting'"
                                                       (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-trialbalance>
</div>

